import { FC } from 'react';

interface IProps {}

const FinancialRowsTitles: FC<IProps> = () => {
  return (
    <div className="financial-results__table--col">
      <div className="montserrat-14-bold financial-results__table--years-row"></div>
      <div className="montserrat-14-bold financial-results__table--row">
        Earning releases
      </div>
      <div className="montserrat-14-bold financial-results__table--row">
        Earning presentation
      </div>
      <div className="montserrat-14-bold financial-results__table--row">
        Transcripts
      </div>
      <div className="montserrat-14-bold financial-results__table--row">
        Quarterly filings
      </div>
      <div className="montserrat-14-bold financial-results__table--row">
        Annual report
      </div>
      <div className="montserrat-14-bold financial-results__table--row">
        Proxy
      </div>
      <div className="montserrat-14-bold financial-results__table--row">
        Proxy supplement
      </div>
    </div>
  );
};

export default FinancialRowsTitles;
